import TransactionsMixin from './_transactions_mixin.js'

// @vue/component
export default {
  mixins: [TransactionsMixin],
  props: {
    mediaProfiles: {
      type: Object,
      required: true
    }
  },
  methods: {
    /*
     * Ir a la página de recarga de un medio específico
     */
    goToRecharge(media) {
      this.$router.push({
        name: 'municipality-recharge',
        params: {
          administrative_area_id: this.$currentAccount.administrative_area_id,
          media_type: media.mediaType,
          media_code: media.mediaCode
        }
      })
    },
    /*
     * Comprobar si un medio de pago es local o de Everilion
     */
    localPaymentMedia(paymentMedia) {
      // Los medios de Everilion no traen los campos 'id' ni 'alias'
      return Boolean(paymentMedia.id)
    }
  }
}
